<template>
  <div class="max-w-12xl mx-auto text-left catalog-search-wrapper">
    <div class="grid grid-cols-12 gap-4 md:h-full grid--filter">
      <!-- FILTER & SORT view, ported from CurriculumFinder: one full-width card
           with the header, a horizontal filter bar, and the results table
           scrolling beneath it. CoverageReport has no second view and no auth,
           so this layout is always on. -->
      <div class="filter-browser col-span-12 flex flex-col">
        <div class="app-card filter-card flex flex-col flex-1 overflow-hidden">
          <div
            class="app-card__body filter-card__body flex flex-col flex-1 overflow-hidden min-h-0"
          >
            <header class="app-header mb-5 flex flex-row">
              <div class="flex-auto">
                <h1 class="ds-heading-display app-h1">
                  Coverage<em class="ds-grad-text">Report</em>
                </h1>
                <div class="text-sm text-mute mt-2">
                  Filter institutions by state, level and control.
                </div>
              </div>
            </header>

            <FilterBar v-model:filters="filters" class="filter-card__bar" />

            <div class="filter-card__table flex-1 min-h-0 overflow-hidden mt-4">
              <CollegeTable :filters="filters" />
            </div>
          </div>

          <footer class="app-footer app-card__footer flex flex-row flex-wrap items-center justify-between gap-4">
            <div class="flex flex-row items-center gap-4">
              <a href="https://degreedata.com" target="_blank" class="flex-none">
                <!-- Bundled, not hotlinked. This pointed at
                     degreedata.com/wp-content/..., which dies the moment the
                     marketing site moves off WordPress onto Webflow. -->
                <img
                  :src="logoSrc"
                  alt="DegreeData Logo"
                  class="w-32 flex-none"
                />
              </a>
              <span class="text-xs text-mute">
                <em>
                  Can't find what you're looking for? Please let us know!
                  <a href="mailto:contact@degreedata.com" class="ds-link">contact@degreedata.com</a>
                </em>
              </span>
            </div>
            <div class="flex flex-row items-center gap-4 text-xs text-mute">
              <span>&copy; {{ currentYear }} DegreeData, LLC</span>
              <a href="https://degreedata.com/privacy-policy/" class="ds-link">
                Privacy Policy
              </a>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilterBar from "./components/FilterBar.vue";
import logoSrc from "@/assets/degreedata-logo.png";

// This app is public — no sign-in or subscription gate. Opening a catalog in
// CurriculumFinder is what prompts a login, and that gate lives in that app.
export default {
  components: {
    FilterBar,
  },
  data() {
    return {
      logoSrc,
      // Filter model shared by FilterBar (controls) and CollegeTable (results).
      // All institutions load up front; every filter narrows rows client-side.
      filters: {
        state: "",
        level: "",
        control: "",
      },
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style>
html,
body,
#app {
  min-height: 100vh;
}

/* Keep #app a plain block, as in CurriculumFinder. Making it a flex column
 * turns .catalog-search-wrapper into a flex item, and a flex item with `mx-auto`
 * cross-axis margins stops stretching and shrinks to its content — which capped
 * the card at the table's min-width instead of filling the viewport. */
#app {
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--ink);
  background: var(--wash);
  font-size: 14px;
}

.catalog-search-wrapper {
  min-height: 100vh;
  padding: 24px;
}

.catalog-search-wrapper > .grid {
  min-height: calc(100vh - 48px);
}

/* Filter/sort browser: from md up, pin the grid to a definite viewport height
 * so the results table scrolls inside its card and keeps its paginator fixed.
 * minmax(0, 1fr) stops a tall table from inflating the row past the viewport.
 * Below md the layout stacks and the page scrolls normally. */
@media (min-width: 768px) {
  .catalog-search-wrapper > .grid--filter {
    height: calc(100vh - 48px);
    grid-template-rows: minmax(0, 1fr);
  }
}

.app-card {
  background: var(--paper);
  border: 1px solid var(--line);
  border-radius: var(--r-card);
  box-shadow: var(--shadow-card);
}

.app-card__body {
  padding: 28px 28px 20px;
}

.app-card__footer {
  border-top: 1px solid var(--line);
  padding: 16px 28px 18px;
}

.app-h1 {
  font-size: 30px;
}

.app-h1 em {
  font-style: normal;
}

/* Filter/sort browser card: header + horizontal filters + scrollable table. */
.filter-card__bar {
  padding-bottom: 4px;
  border-bottom: 1px solid var(--line);
}

.filter-card__table {
  display: flex;
  flex-direction: column;
}

@media (max-width: 767px) {
  .catalog-search-wrapper {
    padding: 16px;
  }
  .app-card__body {
    padding: 20px 20px 16px;
  }
  .app-card__footer {
    padding: 14px 20px 16px;
  }
  .app-h1 {
    font-size: 26px;
  }
}
</style>
